var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0652dbb54ad7549209d528fed8cc8b55.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/221867e349c45e7190784df19265f45c.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/31a7508f8e8c1dba1eca0e66842a0772.js').default;
var scope_3 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/37fef7589e72183a0415332772682789.js').default;
var scope_4 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ddfc5ddd59e3519b3442015448445d32.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    